import React from "react";
import "./style.css";
import tiltArrow from "../../assets/img/tiltArrow.svg";

const CustomLink = ({
  LinkTo,
  customClasses,
  linkText,
  onClick,
  showArrow = true,
  target = "_blank"
}) => {
  const isAITeachersButton = linkText === "Meet Our AI Teachers";
  const isInternalLink = LinkTo && LinkTo.startsWith("#");
  
  return (
    <div className="btn-wrapper">
      <a
        href={LinkTo}
        className={`btn custom-btn ${customClasses} ${isAITeachersButton ? 'ai-teachers-btn' : ''}`}
        onClick={onClick}
        target={isInternalLink ? "_self" : target}
        rel={isInternalLink ? "" : "noopener noreferrer"}
      >
        <span className="link-text">{linkText}</span>
        {showArrow && <img src={tiltArrow} alt="arrow" width="16" height="16" />}
      </a>
    </div>
  );
};

export default CustomLink;
